module.exports = __webpack_public_path__ + "static/demo1-a6835cb6ecefcdbfbb3307e98398272d.mp4";